import cuid from "cuid";
import { find, get } from "lodash";
import { INSURANCE_PLAN_PARAMS_RULES } from "utils/constants";

const EMPTY_CONDITIONS = { operator: "AND", rules: [] };

const normalizeDocumentRow = (doc = {}) => ({
  id: doc.id || cuid(),
  templateId: doc.templateId || "",
  outputName: doc.outputName || "",
  conditions: doc.conditions || EMPTY_CONDITIONS,
});

export const apiToFormGeneratedDocuments = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return [];
  return Object.entries(value).map(([processId, documents]) => ({
    processId,
    documents: (documents || []).map(normalizeDocumentRow),
  }));
};

export const formToApiGeneratedDocuments = (formValue) => {
  if (!Array.isArray(formValue)) return {};
  return formValue.reduce((acc, { processId, documents }) => {
    if (!processId) return acc;
    const rows = (documents || [])
      .filter((doc) => doc.templateId && doc.outputName)
      .map(({ templateId, outputName, conditions }) => ({
        templateId,
        outputName,
        ...(get(conditions, "rules.length", 0) > 0 ? { conditions } : {}),
      }));
    if (rows.length > 0) acc[processId] = rows;
    return acc;
  }, {});
};

export const getGeneratedDocumentsFromParams = (params = []) => {
  const rules = get(params, "[0].rules", []);
  const rule = Array.isArray(rules)
    ? find(rules, { name: INSURANCE_PLAN_PARAMS_RULES.GENERATED_DOCUMENTS })
    : get(rules, INSURANCE_PLAN_PARAMS_RULES.GENERATED_DOCUMENTS);
  return apiToFormGeneratedDocuments(get(rule, "value"));
};

export const toApiDocumentTemplate = (row = {}) => {
  if (!row.templateId) return null;
  return {
    templateId: row.templateId,
    ...(row.type ? { type: row.type } : {}),
    ...(row.area ? { area: row.area } : {}),
    ...(row.outputName ? { outputName: row.outputName } : {}),
    ...(get(row, "conditions.rules.length", 0) > 0
      ? { conditions: row.conditions }
      : {}),
  };
};
